import React, { Component } from 'react';
import { connect } from 'react-redux';
import './NewProposalForm.css';
import ProposalQuote from 'components/admin/work-orders/details/proposals/ProposalQuote';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import { todayValidation } from 'services/utils/date-util';
import Number from 'components/shared/text/Number';
import numeral from 'numeral';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  updateStartDate,
  updateCompletionDate,
} from 'actions/admin/work-orders/details/proposal';

import {
  updateCOStartDate,
  updateCOCompletionDate,
} from 'components/admin/work-orders/details/change-orders/store/actions';

class NewProposalForm extends Component {
  handleCompletionDateChange = (date) => {
    if (this.props.isChangeOrder) {
      this.props.dispatch(updateCOCompletionDate(date));
    } else {
      this.props.dispatch(updateCompletionDate(date));
    }
  };

  handleStartDateChange = (date) => {
    if (this.props.isChangeOrder) {
      this.props.dispatch(updateCOStartDate(date));
    } else {
      this.props.dispatch(updateStartDate(date));
    }
  };

  validateCompletionDate = (date) => {
    if (this.props.startDate !== undefined && this.props.startDate !== null) {
      return date.isAfter(moment(this.props.startDate));
    } else {
      return todayValidation(date);
    }
  };

  renderTotal = (className, label, total) => {
    return (
      <table className={className}>
        <colgroup>
          <col />
          <col />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td />
            <td>{label}</td>
            <td>
              {total > 0 ? <Number value={total} format="$0,0" /> : 'TBD'}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };

  render() {
    let total = 0;
    const props = this.props;
    return (
      <div className="new-proposal-form">
        {props.items.map((item) => {
          total += numeral(item.amount).value() + numeral(item.value).value();
          return (
            <div key={item.id} className="npf-item">
              <ProposalQuote
                itemId={item.id}
                amount={item.amount}
                value={item.value}
                contractor={item.contractorName}
                showValues={true}
                taskNumber={item.task.number}
                taskTrade={
                  item.task.name !== null
                    ? item.task.name
                    : item.task.trade.label
                }
                values={item.values}
                isChangeOrder={props.isChangeOrder}
              />
            </div>
          );
        })}

        {props.isChangeOrder ? (
          <div className="npf-total">
            {this.renderTotal('cost', 'CHANGE ORDER AMOUNT', 0)}
            {this.renderTotal(
              'cost',
              'PREVIOUS CONTRACT AMOUNT',
              this.props.previousCost
            )}
            {this.renderTotal('total', 'NEW CONTRACT AMOUNT', 0)}
          </div>
        ) : (
          <div className="npf-total">
            {this.renderTotal('cost', 'COST', total)}
            {this.renderTotal('total', 'TOTAL', 0)}
          </div>
        )}

        <div className="npf-date-container">
          <span>Start Date</span>
          <DatetimePicker
            format="M/D/YYYY"
            isValidDate={todayValidation}
            placeholder=""
            readOnly={false}
            value={props.startDate}
            onChange={this.handleStartDateChange}
          />
        </div>

        <div className="npf-date-container">
          <span>Completion Date</span>
          <DatetimePicker
            format="M/D/YYYY"
            isValidDate={this.validateCompletionDate}
            placeholder=""
            readOnly={false}
            value={props.completionDate}
            onChange={this.handleCompletionDateChange}
          />
        </div>
      </div>
    );
  }

  static propTypes = {
    completionDate: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
          .isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        contractorName: PropTypes.string.isRequired,
        task: PropTypes.shape.isRequired,
        values: PropTypes.shape({
          fee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          insurance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          markup: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      })
    ),
    startDate: PropTypes.string.isRequired,
  };

  static defaultProps = {
    items: [],
  };
}

export default connect()(NewProposalForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/NewProposalForm.js